// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './Locations.scss';
import { locationModel } from './_variables';
import Location from './Modules/Location';


// COMPONENT
export default function Locations (props) {
   // States and Variables
   const [locations, setLocations] = useState(null);
   const [locationPopups, setLocationPopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Locations"); // set page title
      getLocations();
   }, []);

   // Functions
   const getLocations = function () {
      OHSCRUD({
         url: '/v1/oneport/locations',
         method: 'GET',
         success: function (data) {
            setLocations(OHSListDataFormatter(data, locationModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const addLocation = function () {
      OHSCRUD({
         url: '/v1/oneport/locations',
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-locations-add'),
         success: function (data) {
            if (locations.length > 0) {
               setLocations([...locations, OHSListDataFormatter(data[0], locationModel)]);
            } else {
               setLocations([OHSListDataFormatter(data[0], locationModel)]);
            }
            OHSFormDataClearer('oneport-locations-add');
            props.onehive.appWideContent.oneport.buildNavigation(); // refresh the locations + devices in the nav menu
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div className="oneport-locations">
         <OHSAppHeader onehive={props.onehive} title="Locations" help="https://www.onehivesystems.com/documentation/oneport/locations" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='oneport-locations-add' title="Add a Location" onEnter={addLocation}>
               <OHSFormItem onehive={props.onehive} title="Name">
                  <input type='text' className='ohsinput' data-ohsformdata='name' />
               </OHSFormItem>
               <OHSFormSubmit onehive={props.onehive} add={addLocation} clear={() => {OHSFormDataClearer('oneport-locations-add');}} keyListener={true} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Locations" container='oneport-locations-list' />
            <OHSWidget onehive={props.onehive} id='oneport-locations-list' title="List of Locations">
               <OHSList onehive={props.onehive} content={locations} popups={locationPopups} setPopups={setLocationPopups} template={
                  <Location onehive={props.onehive} parent={{
                     locations: locations,
                     setLocations: setLocations
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}